/**
 * @desc 用户同步
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.IAMCommonRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/iam/callback/staff`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
